// Application-wide constants

// Yard Management
export const MAX_TILES = 999;

// GraphQL API
export const GRAPHQL_API_URL = process.env.REACT_APP_GRAPHQL_API || 'http://localhost:4000/api/graphql';

// WebSocket
export const REPORTS_WEBSOCKET_URL =
  process.env.REACT_APP_REPORTS_WEBSOCKET_URL || 'ws://localhost:4000/reports_socket';

// Refresh intervals (in milliseconds)
export const DEFAULT_REFRESH_INTERVAL = 30000; // 30 seconds
export const DRIVER_COMMS_REFRESH_INTERVAL = 7500; // 7.5 seconds

